import axios from "axios";

export default {
  get(paginationString) {
    if (paginationString) {
      return axios.get(`/api/orderOneStryker${paginationString.text}`);
    } else {
      return axios.get("/api/orderOneStryker");
    }
  },
  getCommands(data) {
    if (data.pagination) {
      return axios.get(
        `/api/orderOneStryker/customer/${data.customer}/query${data.pagination}`
      );
    } else {
      return axios.get(`/api/orderOneStryker/customer/${data.customer}/query`);
    }
  },
  createOrder(data) {
    return axios.post(`/api/orderOneStryker/createOrderFromCart`, data);
  },
  downloadInvoice(id) {
    return axios.get("/api/orderOneStryker/download/" + id, {
      responseType: "blob",
    });
  },
  recalculateColumns() {
    return axios.post("/api/orderOneStryker/recalculate-custom-columns");
  },
  getDetails(id) {
    return axios.get(`/api/orderOneStryker/${id}/details`);
  },
  deleteOrder(orderId) {
    return axios.delete(`/api/orderOneStryker/${orderId}`);
  },
};
